// Components
import { UpdateMinesProviderConfigForm } from './UpdateMinesProviderConfigForm';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
// Redux
import { useUpdateMinesProviderConfig } from '@Modal/hooks/providers/useUpdateMinesProviderConfig';
// styles
import Styles from './UpdateMinesProviderConfigModalDialog.module.scss';

export const UpdateMinesProviderConfigModalDialog = () => {
  const { showUpdateMinesProviderConfigForm, handleUpdateCancel } = useUpdateMinesProviderConfig();

  return (
    <>
      {showUpdateMinesProviderConfigForm && (
        <ClosableModal
          name="UpdateMinesProviderConfig"
          title="Update MinesProvider Config"
          open={showUpdateMinesProviderConfigForm}
          onClose={handleUpdateCancel}
          className={Styles.UpdateMinesProviderConfigModalDialog}
          sx={{ height: 'auto', overflowY: 'scroll', width: '592px' }}
        >
          <UpdateMinesProviderConfigForm />
        </ClosableModal>
      )}
    </>
  );
};
